<!-- 温度设置 -->
<template>
    <div class='container containerBox'>
         <!-- 头部筛选区 -->
        <el-alert title="设置参数前请确认PLC设备" type="warning" show-icon center></el-alert>
        <el-form class="demo-form-inline" style="margin: 10px 0;">
            <el-form-item label="PLC设备">
                <el-select v-model="terminal_id" placeholder="请选择设备" @change="handleChangePLC">
                    <el-option
                        v-for="item in deviceList"
                        :key="item.oid"
                        :label="item.customized_serial+'：'+item.terminal_serial"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form label-width="150px" :model="form">
            <el-row :gutter="20">
                <el-col :span="6"></el-col>
                <el-col :span="12">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>温度设置</span>
                        </div>
                        <template v-for="(v, i) in temperature_List">
                            <el-row :gutter="20" class="item" :key="i">
                                <el-col :span="18">{{v.label}}</el-col>
                                <el-col :span="6">
                                    <span @click="handleClick(v, 'temperature_List')" class="input">{{v.value}}</span>
                                    <span>{{v.unit}}</span>
                                </el-col>
                            </el-row>
                        </template>
                    </el-card>
                </el-col>
                <el-col :span="6"></el-col>
            </el-row>
        </el-form>

        <el-dialog title="请输入控制值" :visible.sync="dialogFormVisible">
            <el-form :model="controlForm">
                <el-form-item label="控制值">
                    <el-input v-model="controlForm.value" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="controlServer()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Service from '@/api/Service'
import { mapGetters } from "vuex";
import { computedUtil2, computedUtil1 } from '@/utils/utils'
import checkPermission from '@/utils/permission'

const setting_type1 = 6     //  温度设置

export default {
    data() {
        return {
            form: {},
            collectorList: [], // 集控器列表
            collectorId: "",    // 集控区ID
            deviceList: [], // 设备列表
            deviceId: "",   //  标记ID
            tableData: [], //   变量列表
            
            machineVarConfig: [],   //  addr配置
            ServerRoom: [],

            temperature_List: [],  //  温度设置

            ws_data: {},

            controlForm: {
                value: '',
            },
            dialogFormVisible: false,
			plcdata:{},
            terminal_id: '',
            controlModlue: ""
        };
    },

    async created() {
        await this.getDeviceList();
    },
    computed: {
        // 项目信息
    },

    methods: {
        // 获取全部PLC
        async getDeviceList() {
            let params = Object.assign({}, { page_num: 1, page_sum: 40 });
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.deviceList = list;
                this.terminal_id = list[0].oid
                await this.getServerRoombypid();
                await this.handleChangePLC(list[0].oid)
               
            }
        },
        // 获取PLC addr配置
        async handleChangePLC(terminal_id) {
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 500,
            }
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.machineVarConfig = list;
                this.handleChangeVar()
                await this.getCurrentReading(terminal_id)
            }
        },
        async getServerRoombypid() {
            let res = await Service.getServerRoombypid();
            res = res === "success" ? [] : res;
            if(res.length>0) {
                this.ServerRoom = res;
            }
        },
        handleChangeVar() {
                let setting_data1 = this.ServerRoom.filter(v=>{return v.setting_type === setting_type1 && v.terminal_id === this.terminal_id})[0];
                this.temperature_List = setting_data1 ? JSON.parse(setting_data1.setting_data) : [] 
        },
        // 获取PLC当前数据
        async getCurrentReading(oid){
            let res = await Service.getPlcCurrentReadings({oid});
            if(res != 'success'){
				// data.map(v=>{
				//     this.ws_data[v.addr] = v.data
				// })
                let data = res.data || []
				this.plcdata=data
                this.fmtData()
            }
        },
       
        fmtData() {
            this.temperature_List = this.temperature_List.map(v=>{
                let obj = this.machineVarConfig.filter(v1 => {
                    return v1.var_Initial_addr === v.addr
                })
				var str=JSON.stringify(obj[0].var_Initial_addr)+'_'+JSON.stringify(obj[0].opcode)
				for(var key in this.plcdata){
					if(key == str){
						v.value = this.plcdata[key]
					}
				}
                v.unit = obj[0].unit
                return v
            })
        },
        async handleClick(v, name) {
            if(!checkPermission('tempsetting')) {
                this.$message({
                    type: 'warn',
                    message: `该账号只有可读权限，无法设置参数值`
                });
                return
            }
            this.controlModlue = name
            this.controlForm = {
                opcode: 6,
                terminalid: this.terminal_id,
                addrstart : v.addr
            }
            this.dialogFormVisible = true;
        },
        async controlServer() {
            if(this.controlForm.value.trim() == '' || isNaN(this.controlForm.value)) {
               
                this.$message({
                    type: 'warn',
                    message: `输入值有误，请重新输入`
                });
                return
            }

            // 判断范围
            let obj = this.machineVarConfig.filter((v)=>{return v.var_Initial_addr === this.controlForm.addrstart})
            let min = obj[0].range_min,
                max = obj[0].range_max;
            if(obj[0].linear_conversion)
            {
                if(min>this.controlForm.value || max<this.controlForm.value ) {
                    this.$message({
                        type: 'warn',
                        message: `请输入${min}-${max}范围内的值`
                    });
                    return
                }
            }

            let params = Object.assign({}, this.controlForm);
            // 工程换算
            params.value = computedUtil1(params.value, obj);
            
            let res = await Service.controlPlcinteraction(params);
            if(res) {
                this.$message({
                    type: 'success',
                    message: '发送成功!'
                });

                // 设置值赋值
                let arr = this[this.controlModlue];
                arr.map(v=>{
                    if(v.addr === this.controlForm.addrstart) {
                        v.value = this.controlForm.value
                    }
                })
                this.dialogFormVisible = false;
                setTimeout(() => {
                    let oid = this.terminal_id
                    this.getCurrentReading(oid)
                }, 10000);
            }
        },
    }
}

</script>
<style lang='less'>
.box-card{
    .item {
        height: 40px;
        line-height: 40px;
        margin-bottom: 10px;
        span{
            font-size: 14px;
            display: inline-block;
            vertical-align: middle;
            &.input{
                line-height: 38px;
                height: 38px;
                border: 1px solid #ccc;
                padding: 0 10px;
                cursor: pointer;
                width: 50px;
            }
        }
    }
}

</style>